import { useHistory } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import { Rudderstack } from './events';

const getReferrer = () => ({
  referrer: document.location.href || '',
  referring_domain: document.location.host || '',
});

export const usePageviewTracking = () => {
  const history = useHistory();
  const ref = useRef(getReferrer());

  useEffect(() => {
    const unlisten = history.listen(() => {
      Rudderstack.pageview(null, {
        referring_domain: ref.current.referring_domain,
        referrer: ref.current.referrer,
        url: document.location.href,
      });
    });

    return () => {
      unlisten();
    };
  }, []);
};
